export const enterpriseNav = [
  {
    id: 'enterprise-header',
    textId: 'app.pages.enterprise.nav.header',
    exist: true,
  },
  {
    id: 'pages-top-decisions',
    textId: 'app.pages.enterprise.nav.topDecisions',
    exist: false,
  },
  {
    id: 'enterprise-cases',
    textId: 'app.pages.enterprise.nav.cases',
    exist: false,
  },
  {
    id: 'enterprise-representing',
    textId: 'app.pages.enterprise.nav.representing',
    exist: false,
  },
  {
    id: 'enterprise-opponents',
    textId: 'app.pages.enterprise.nav.opponents',
    exist: false,
  },
];
